import { render, staticRenderFns } from "./LayOut.vue?vue&type=template&id=46b4fe3e"
import script from "./LayOut.vue?vue&type=script&lang=js"
export * from "./LayOut.vue?vue&type=script&lang=js"
import style0 from "./LayOut.vue?vue&type=style&index=0&id=46b4fe3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports